import { useEffect, useState } from 'react';
import { adminAPI } from '@/lib/api';
import { formatMoney, prettyPlan } from '@/lib/format';

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const load = () => adminAPI.orders().then(setOrders);
  useEffect(() => { load(); }, []);
  const markPaid = async (id) => { await adminAPI.markOrderPaid(id); load(); };
  return (
    <div className="space-y-4">
      <h1 className="font-display text-3xl">Orders</h1>
      <div className="card-tech rounded-lg overflow-x-auto">
        <div className="min-w-[980px]">
          <div className="grid grid-cols-[1.2fr_1.2fr_1fr_1fr_1fr_1fr_1fr_1fr] gap-3 px-4 py-3 label-xs border-b border-white/5">
            <div>ORDER</div><div>USER</div><div>PLAN</div><div>SIZE</div><div>AMOUNT</div><div>TYPE</div><div>STATUS</div><div>ACTIONS</div>
          </div>
          {orders.map(o => (
            <div key={o.order_id} className="grid grid-cols-[1.2fr_1.2fr_1fr_1fr_1fr_1fr_1fr_1fr] gap-3 px-4 py-3 border-b border-white/5 text-sm items-center" data-testid={`admin-order-${o.order_id}`}>
              <div className="font-mono truncate">{o.order_id}</div>
              <div className="truncate">{o.user_email}</div>
              <div>{prettyPlan(o.plan_id)}</div>
              <div className="font-mono">${o.account_size}</div>
              <div className="font-mono">${formatMoney(o.amount_usd)}</div>
              <div className="font-mono text-xs">{o.order_type}</div>
              <div><span className={`chip ${o.status === 'paid' ? 'chip-green' : o.status === 'pending' ? 'chip-yellow' : 'chip-red'}`}>{(o.status || '').toUpperCase()}</span></div>
              <div>
                {o.status === 'pending' && <button className="btn-ghost btn-sm" onClick={() => markPaid(o.order_id)} data-testid={`mark-paid-${o.order_id}`}>Mark paid</button>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
